import { render } from "./new-password.vue?vue&type=template&id=87bf52dc&scoped=true&ts=true"
import script from "./new-password.vue?vue&type=script&lang=ts"
export * from "./new-password.vue?vue&type=script&lang=ts"

import "./new-password.vue?vue&type=style&index=0&id=87bf52dc&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87bf52dc"]])

export default __exports__